import * as React from "react";
const autobind = require("class-autobind").default;
import { logger } from "@lib/common";
import { SelectAdv } from "../../form/select.adv/index";
export class FieldFont extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            loading: false,
            fonts: [],
        };
    }
    async componentDidMount() {
        try {
            const fonts = await this.props.google.fonts.list();
            this.setState({ fonts });
        }
        catch (e) {
            logger.captureException(e);
        }
    }
    onChange(family) {
        const font = this.state.fonts.find((f) => f.family === family);
        if (family && font) {
            let query = `${font.family}:`;
            const variantsLength = font.variants.length;
            font.variants.forEach((v, i) => {
                if (i + 1 === variantsLength)
                    query += v;
                else
                    query += v + ",";
            });
            this.props.onChange({
                family: font.family,
                category: font.category,
                query: query,
            });
        }
    }
    render() {
        const { value } = this.props;
        if (this.state.fonts.length === 0)
            return React.createElement("p", null, "Loading Fonts...");
        return (React.createElement(SelectAdv, { type: "single", searchOnly: true, value: value, onChange: this.onChange, options: this.state.fonts }));
    }
}
//# sourceMappingURL=index.js.map